import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";
export var FadeAnimatedContainer = function(param) {
    var willRender = param.willRender, fadeInDuration = param.fadeInDuration, fadeOutDuration = param.fadeOutDuration, children = param.children;
    var _React_useState = _sliced_to_array(React.useState(willRender), 2), shouldRender = _React_useState[0], setShouldRender = _React_useState[1];
    useEffect(function() {
        if (willRender) {
            setShouldRender(willRender);
        }
    }, [
        willRender
    ]);
    return shouldRender ? /*#__PURE__*/ _jsx(Wrapper, {
        onAnimationEnd: function() {
            setShouldRender(willRender);
        },
        $show: willRender,
        $fadeInDuration: fadeInDuration !== null && fadeInDuration !== void 0 ? fadeInDuration : 500,
        $fadeOutDuration: fadeOutDuration !== null && fadeOutDuration !== void 0 ? fadeOutDuration : 500,
        "data-test-id": "fade-animated-container",
        children: children
    }) : null;
};
var fadeInAnimation = keyframes([
    "0%{opacity:0;}100%{opacity:100;}"
]);
var fadeOutAnimation = keyframes([
    "0%{opacity:100;}100%{opacity:0;}"
]);
var Wrapper = styled.div.withConfig({
    componentId: "sc-7e153fc6-0"
})([
    "animation:",
    " ",
    "ms linear forwards;"
], function(props) {
    return props.$show ? fadeInAnimation : fadeOutAnimation;
}, function(props) {
    return props.$show ? props.$fadeInDuration : props.$fadeOutDuration;
});
